import { makeCommunicationActionCreators } from 'shared/helpers/redux';
import * as NS from '../../types';

export const { execute: loadAmpCampaigns, completed: loadAmpCampaignsSuccess, failed: loadAmpCampaignsFailed } =
  makeCommunicationActionCreators<NS.LoadAmpCampaigns, NS.LoadAmpCampaignsSuccess, NS.LoadAmpCampaignsFail>(
    'AMP_CAMPAIGNS_SERVICE:LOAD_AMP_CAMPAIGNS', 'AMP_CAMPAIGNS_SERVICE:LOAD_AMP_CAMPAIGNS_SUCCESS', 'AMP_CAMPAIGNS_SERVICE:LOAD_AMP_CAMPAIGNS_FAIL',
  );
